<template>
	<div 
		v-if="!isAutoEmail"
		class="visor-marketing-waitlist-cta"
	>
		<div 
			class="form-header"
		>
			<div 
				v-if="!autoEmailSuccess"
				class="title-grey"
			>
				Reserve your spot today.
			</div>
		</div>
		<div class="submit-email-cta">
			<div 
				v-if="!submittedSuccess"
				name="sign-up-form" 
				data-name="Sign In Form" 
				class="form-horizontal"
			>
				<input 
					type="email"
					class="email-input"
					name="email" 
					data-name="Email" 
					placeholder="Email Address" 
					id="email" 
					v-model="emailAddress"
				>
				<div 
					v-if="submitError"
					class="email-error"
				>
					{{ submitError }}
				</div>
				<r-button
					theme="blue"
					size="huge"
					fullWidth
					@click="submitEmail"
				>
					Reserve My Spot
				</r-button>
				<div
					class="field-row"
				>
					<span 
						class="label-area"
					>
						<span class="checkbox-label">By clicking the button above, you agree to Visor's <a class="inline-link" :href="VisorGlobalConfig.externalLinks.termsOfUse" target="_blank" >Terms of Use</a> and that you have read our <a class="inline-link" :href="VisorGlobalConfig.externalLinks.privacyPolicy" target="_blank" >Privacy Policy</a>.</span>
					</span>
				</div>
			</div>
			<div 
				v-else
				class="submitted-success" 
				:class="{
					'auto-email': autoEmailSuccess,
				}"
			>
				Congratulations, you're on the list!
			</div>
		</div>
	</div>
	<div
		v-else
		class="visor-marketing-waitlist-cta"
	>
	</div>
</template>

<script>

	export default {
		$pubsub:{
			routerNavigation:{
				subscriptions:{
					beforeRouteChanged(){
						this.$el.scrollTo(0, 0);
					}
				}
			}			
		},
		data(){
			return {
				emailAddress: null,
				submitError: null,
				submittedSuccess: false,
				isAutoEmail: false,
				autoEmailSuccess: false,
			};
		},
		inject: ['Telemetry'],
		props:{
			email:{
				required: false,
				type: String,
			}
		},
		created(){
			if(this.email){
				// try to submit the email right away
				this.isAutoEmail = true;
				this.emailAddress = this.email;
				this.submitEmail();
			}
		},
		mounted(){
		},
		watch:{

		},
		computed:{
			signUpEnabled(){
				return this.emailValid;
			},
			emailValid(){
				if(this.emailAddress && this.emailAddress.trim().length > 0){
					if(!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.emailAddress.trim()))){
						return false;
					}
					else{
						return true;
					}
				}
				else{
					return false;
				}
			},
		},
		methods:{
			submitEmail(){
				const vcSelf = this;
				const hubspotFormGUID = '53a11829-fa0d-43f2-bcbc-e704bf50fe1b';
				const formFields = {
					'email': vcSelf.emailAddress,
				};

				vcSelf.submitError = null;

				if(vcSelf.emailValid){
					vcSelf.Telemetry.providerControllers.hubspot.submitForm(hubspotFormGUID, formFields, function onHubspotFormSubmitted(results){
						if(results.status === 'success'){
							vcSelf.submittedSuccess = true;

							if(vcSelf.isAutoEmail){
								vcSelf.isAutoEmail = false;
								vcSelf.autoEmailSuccess = true;
							}
						}
						else{
							vcSelf.submitError = "Please enter a vaild email and try again";
							if(vcSelf.isAutoEmail){
								vcSelf.isAutoEmail = false;
								vcSelf.autoEmailSuccess = false;
							}
						}
					});
				}
				else{
					vcSelf.submitError = "Please enter a vaild email and try again";
					if(vcSelf.isAutoEmail){
						vcSelf.isAutoEmail = false;
						vcSelf.autoEmailSuccess = false;
					}
				}

				return;
			}
		},
	}

</script>

<style lang="scss" scoped>
	
	.visor-marketing-waitlist-cta{

		font-family: 'Inter', sans-serif;
		background: $p-color-black;
		color: $p-color-white;
		max-width: 740px;
		margin: auto;
		min-height: 240px;

		.form-header{
			margin-bottom: 12px;

			.title-white{
				display: inline;
				margin-top: 0px;
				margin-bottom: 24px;
				color: $p-color-white;
				font-size: 40px;
				line-height: 44px;
				font-weight: 600;
				letter-spacing: -0.02em;
			}
			.title-grey{
				color: $p-color-grey-400;
				font-size: 40px;
				line-height: 44px;
				font-weight: 600;
				letter-spacing: -0.02em;

				@media screen and (max-width: 600px){
					font-size: 36px;
					line-height: 40px;
				}
			}
		}

		.submit-email-cta{

			.form-horizontal{
				display: grid;
				grid-auto-columns: 1fr;
				grid-row-gap: 12px;
				grid-template-areas: ".";
				-ms-grid-columns: 1fr;
				grid-template-columns: 1fr;
				-ms-grid-rows: auto 12px auto;
				grid-template-rows: auto auto;
				position: relative;

				.email-input{
					height: 60px;
					padding-right: 24px;
					padding-left: 24px;
					margin-bottom: 0px;
					border: 1px none #000;
					border-radius: 6px;
					background-color: hsla(0, 0%, 100%, 0.1);
					-webkit-transition: background-color 200ms ease;
					transition: background-color 200ms ease;
					color: #fff;
					font-size: 16px;
					line-height: 24px;
					max-width: 100%;
				}

				.email-error{
					font-family: Inter, sans-serif;
					color: $p-color-red-300;
					font-weight: 600;
					text-decoration: none;
				}
				
				.field-row{
					display: -webkit-box;
					display: -webkit-flex;
					display: -ms-flexbox;
					display: flex;
					margin-bottom: 0px;
					padding-left: 0px;
					-webkit-box-orient: horizontal;
					-webkit-box-direction: normal;
					-webkit-flex-direction: row;
					-ms-flex-direction: row;
					flex-direction: row;
					-webkit-box-align: center;
					-webkit-align-items: center;
					-ms-flex-align: center;
					align-items: center;

					.checkmark-area{
						height: 24px;
						width: 24px;
					}

					.label-area{
						font-family: 'Inter', sans-serif;
						font-size: 14px;
						line-height: 20px;
						letter-spacing: 0.15px;
						color: $p-color-grey-600;
						cursor: default;
					}

					.checkbox-label{
						margin-bottom: 0px;
						color: $p-color-grey-400;
						font-size: 14px;
						line-height: 22px;
						font-weight: 600;
						letter-spacing: 0em;
						text-decoration: none;
					}

					.inline-link{
						font-family: Inter, sans-serif;
						color: $p-color-grey-200;
						font-weight: 500;
						text-decoration: none;

						&:hover{
							color: $p-color-white;
						}
					}
				}
			}
			.submitted-success{
				margin-top: 0px;
				margin-bottom: 24px;
				color: $p-color-green-300;
				font-size: 40px;
				line-height: 44px;
				font-weight: 600;
				letter-spacing: -0.02em;

				&.auto-email{
					text-align: center;
				}

				@media screen and (max-width: 600px){
					font-size: 36px;
					line-height: 40px;
				}
			}
		}
	}

</style>
